export var SupportingDocumentContext;
(function (SupportingDocumentContext) {
    SupportingDocumentContext["KYC_MISMATCH"] = "KYC_MISMATCH";
    SupportingDocumentContext["BANK_MISMATCH"] = "BANK_MISMATCH";
    SupportingDocumentContext["PHOTO_MISMATCH"] = "PHOTO_MISMATCH";
})(SupportingDocumentContext || (SupportingDocumentContext = {}));
